import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "../../lib/api";
import { Card, Overline, StatCard, Pill, Btn, Icon, PageLoader, SectionTitle } from "../../components/ui-kit";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";
import { toast } from "sonner";

export default function StudentProfile() {
  const { id } = useParams();
  const [d, setD] = useState(null);
  useEffect(() => { api.get(`/teacher/student/${id}`).then(({ data }) => setD(data)); }, [id]);
  if (!d) return <PageLoader />;
  const s = d.student;

  return (
    <div className="max-w-4xl mx-auto p-4 sm:p-6 space-y-6">
      <Link to="/teacher/students" className="inline-flex items-center gap-1 text-sm text-mim-muted hover:text-mim-navy"><Icon name="ArrowLeft" className="w-4 h-4" />Students</Link>
      <div className="flex items-center gap-4">
        <div className="w-16 h-16 rounded-2xl bg-mim-soft text-mim-blue flex items-center justify-center text-xl font-bold">{s.name.split(" ").map(n=>n[0]).join("")}</div>
        <div><Overline>Student Profile</Overline><h1 className="text-2xl font-bold text-mim-navy">{s.name}</h1></div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <StatCard icon="Award" label="Mastery" value={`${s.mastery}%`} tone="blue" />
        <StatCard icon="BookCheck" label="Completed" value={d.completed} tone="green" />
        <StatCard icon="Flame" label="Streak" value={`${s.streak}d`} tone="yellow" />
        <StatCard icon="Zap" label="XP" value={s.xp} tone="purple" />
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        <Card>
          <SectionTitle title="Accuracy Trend" icon="TrendingUp" />
          {d.trend.length ? (
            <ResponsiveContainer width="100%" height={200}>
              <LineChart data={d.trend}><CartesianGrid strokeDasharray="3 3" stroke="#E8EEF6" />
                <XAxis dataKey="date" tick={{ fontSize: 11, fill: "#71809B" }} tickFormatter={(v)=>v.slice(5)} /><YAxis domain={[0,100]} tick={{ fontSize: 11, fill: "#71809B" }} />
                <Tooltip contentStyle={{ borderRadius: 12, border: "1px solid #DCE5F0" }} />
                <Line type="monotone" dataKey="accuracy" stroke="#2477E8" strokeWidth={3} dot={{ r: 3 }} />
              </LineChart>
            </ResponsiveContainer>
          ) : <p className="text-sm text-mim-muted">No quiz data yet.</p>}
        </Card>
        <Card>
          <SectionTitle title="Weak Areas" icon="Target" />
          {d.weak_areas.length === 0 ? <p className="text-sm text-mim-muted">No weak areas 🎉</p> : (
            <div className="space-y-3">
              {d.weak_areas.map((w) => (
                <div key={w.id} className="flex items-center justify-between">
                  <div><div className="font-semibold text-mim-navy text-sm">{w.name}</div><div className="text-xs text-mim-muted">{w.reason}</div></div>
                  <Pill tone="coral">{w.accuracy}%</Pill>
                </div>
              ))}
            </div>
          )}
          <div className="flex gap-2 mt-4">
            <Btn variant="secondary" className="flex-1" icon="RotateCcw" onClick={() => toast.success("Revision assigned")}>Assign Revision</Btn>
            <Btn className="flex-1" icon="CircleHelp" onClick={() => toast.success("Quiz created")}>Create Quiz</Btn>
          </div>
        </Card>
      </div>
    </div>
  );
}
